var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('alert',{attrs:{"is-open":_vm.show,"type-alert":_vm.internetStatus ? 'success' : 'error',"text-alert":_vm.message}})}
var staticRenderFns = []

export { render, staticRenderFns }